/**
 * Created by simon on 2018-12-27.
 */

export const LSSBerPerInt = [
	{value: '001', text: '1 månad'},
	{value: '002', text: '2 månader'},
	{value: '003', text: '3 månader'},
	{value: '004', text: '4 månader'},
	{value: '005', text: '5 månader'},
	{value: '006', text: '6 månader'},
	{value: '104', text: '4 veckor'},
];

export const PerTyp = [
	{value: 'ARB', text: 'Arbetare'},
	{value: 'TJM', text: 'Tjänsteman'},
	{value: 'LED', text: 'Företagsledning'},
	{value: 'DEL', text: 'Delägare'},
	{value: 'IDR', text: 'Idrottsutövare'},
	{value: 'ÖVR', text: 'Annan'},
];

export const AnstForm = [
	{value: 'TV', text: 'Tillsvidareanställning'},
	{value: 'PRO', text: 'Provanställning'},
	{value: 'TID', text: 'Visstidsanställning'},
	{value: 'VIK', text: 'Vikariat'},
	{value: 'PEN', text: 'Efter pensionering'},
	{value: 'PRJ', text: 'Projektanställning'},
	{value: 'PRA', text: 'Praktikarbete'},
	{value: 'FER', text: 'Feriearbete'},
	{value: 'SES', text: 'Säsongsanställd'},
	{value: 'AVT', text: 'Särskilt avtal'},
	{value: 'NEJ', text: 'Ej anställd'},
];

export const LoneForm = [
	{value: 'MÅN', text: 'Månadslön (Fast lön)'},
	{value: 'TIM', text: 'Timlön (Rörlig lön)'},
];

export const KalReadyTyp = [
	{value: 'DAG', text: 'Hela dagar'},
	{value: 'TID', text: 'Endast tider'},
];

export const KalAutoSchematid = [
	{value: 'NULL', text: 'Om schema saknas helt på dagen'},
	{value: 'NOLL', text: 'Vid registrering av tid på ledig dag'},
	{value: 'FILL', text: 'Om registrerad tid är mer än schematiden'},
];

export const StartBokfAr = [
	{text: 'Januari', value: '01'},
	{text: 'Februari', value: '02'},
	{text: 'Mars', value: '03'},
	{text: 'April', value: '04'},
	{text: 'Maj', value: '05'},
	{text: 'Juni', value: '06'},
	{text: 'Juli', value: '07'},
	{text: 'Augusti', value: '08'},
	{text: 'September', value: '09'},
	{text: 'Oktober', value: '10'},
	{text: 'November', value: '11'},
	{text: 'December', value: '12'},
];

export const MonthList = [
	{text: 'Januari', value: 1},
	{text: 'Februari', value: 2},
	{text: 'Mars', value: 3},
	{text: 'April', value: 4},
	{text: 'Maj', value: 5},
	{text: 'Juni', value: 6},
	{text: 'Juli', value: 7},
	{text: 'Augusti', value: 8},
	{text: 'September', value: 9},
	{text: 'Oktober', value: 10},
	{text: 'November', value: 11},
	{text: 'December', value: 12},
];

export const KalLss = [
	{value: 'NEJ', text: 'Ingen'},
	{value: 'TID', text: 'Övrig tid'},
	{value: 'ASS', text: 'Assistanstid'},
	{value: 'JOR', text: 'Jourtid'},
	{value: 'BER', text: 'Beredskapstid'},
	{value: 'FRA', text: 'Frånvarotid'},
];

export const KalObe = [
	{value: 'NEJ', text: 'Ingen'},
	{value: 'OVT', text: 'Övertid'},
	{value: 'NAR', text: 'Närvarotid'},
	{value: 'SCH', text: 'Schematid'},
	{value: 'ARB', text: 'Arbetstid'},
	{value: 'SJK', text: 'Sjukfrånvaro'},
	{value: 'FRA', text: 'Frånvarotid'},
];

export const DagTyp = [
	{value: '--', text: 'Ingen avvikelse'},
	{value: '10', text: 'Vardag'},
	{value: '16', text: 'Lördag'},
	{value: '17', text: 'Söndag'},
	{value: 'HA', text: 'Helgafton'},
	{value: 'HD', text: 'Helgdag'},
	{value: 'HK', text: 'Klämdag helg'},
	{value: 'SA', text: 'Storhelgsafton'},
	{value: 'SD', text: 'Storhelgsdag'},
	{value: 'SK', text: 'Klämdag storhelg'},
	{value: 'YA', text: 'Nyårsafton'},
	{value: 'YD', text: 'Nyårsdagen'},
	{value: 'TA', text: 'Trettondagsafton'},
	{value: 'TD', text: 'Trettondagen'},
	{value: 'PT', text: 'Skärtorsdagen'},
	{value: 'PF', text: 'Långfredagen'},
	{value: 'PA', text: 'Påskafton'},
	{value: 'PD', text: 'Påskdagen'},
	{value: 'PE', text: 'Annandag påsk'},
	{value: 'FA', text: 'Valborgsafton'},
	{value: 'FD', text: 'Första maj'},
	{value: 'KD', text: 'Kristi himmelsfärdsdag'},
	{value: 'IA', text: 'Pingstafton'},
	{value: 'ID', text: 'Pingstdagen'},
	{value: 'ND', text: 'Nationaldagen'},
	{value: 'MA', text: 'Midsommarafton'},
	{value: 'MD', text: 'Midsommardagen'},
	{value: 'AD', text: 'Alla helgons dag'},
	{value: 'JA', text: 'Julafton'},
	{value: 'JD', text: 'Juldagen'},
	{value: 'JE', text: 'Annandag jul'},
];

export const UtbetPer = [
	{value: 'M', text: 'Månadslön, innevarande'},
	{value: 'K', text: 'Månadslön, föregående'},
	{value: 'V', text: 'Veckolön'},
	{value: 'W', text: 'Tvåveckorslön'},
	{value: 'Q', text: 'Fyraveckorslön'},
	{value: 'H', text: 'Halvmånadslön'},
	{value: '-', text: 'Ingår ej i lönekörning'},
];

export const Jamkning = [
	{value: '%', text: '% i skatt'},
	// {value: '+', text: 'kr ökat underlag'},
	// {value: '-', text: 'kr minskat underlag'},
	// {value: '0', text: 'ingen skatt'},
];

export const KlassTyp = [
	{value: 'BRU+', text: 'Bruttolön'},
	{value: 'BRU-', text: 'Bruttoavdrag'},
	{value: 'NAT+', text: 'Naturaförmån'},
	{value: 'KOA-', text: 'Kostnadsavdrag'},
	{value: 'TID-', text: 'Tidsavdrag'},
	{value: 'TID+', text: 'Tidslöneart'},
	{value: 'PAS+', text: 'Passiv'},
	{value: 'PAS-', text: 'Passiv avdrag'},
	{value: 'NET+', text: 'Nettoersättning'},
	{value: 'NET-', text: 'Nettoavdrag'},
	{value: 'SKT-', text: 'Frivillig skatt'},
];

export const SkatteTyp = [
	{value: 'SG', text: 'Skattegrundande'},
	{value: 'ES', text: 'Engångsskattegrundande'},
	{value: 'KS', text: 'Kapitalskattegrundande'},
	{value: 'SF', text: 'Skattefri'},
];

export const UtbetTyp = [
	{value: 'BNK', text: 'Bank kontoinsättning'},
	{value: 'BNU', text: 'Bank utbetalningskort'},
	{value: 'PGU', text: 'Plusgiro utbetalningslista'},
	{value: 'KON', text: 'Kontantlista'},
];

export const KontUppgift = [
	{value: '00', text: 'Redovisas ej'},
	{value: '11', text: 'Kontant bruttolön m.m (bruttoavdrag) (011)'},
	{value: '12', text: 'Skattepliktiga förmåner utom bil- och drivmedel (012)'},
	{value: '13', text: 'Skattepliktig bilförmån utom drivmedel (013)'},
	{value: '16', text: 'Antal km med milersättning vid bilförmån (016)'},
	{value: '17', text: 'Betalt för bilförmån (017)'},
	{value: '18', text: 'Drivmedel vid bilförmån (018)'},
	{value: '20', text: 'Kostnadsersättning som inte kryssats vid kod 050-057 (020)'},
	{value: '21', text: 'Underlag för skattereduktion för hushållsarbete (021)'},
	{value: '22', text: 'Underlag för skattereduktion för ROT-arbete (022)'},
	{value: '23', text: 'Andel styrelsearvode (023)'},
	{value: '25', text: 'Skattepliktig ersättning grundande för egenavgifter (025)'},
	{value: '30', text: 'Tjänstepension (030)'},
	{value: '31', text: 'Skattepliktiga ersättningar, ej socialavgifter men jobbavdrag (031)'},
	{value: '32', text: 'Skattepliktiga ersättningar, ej socialavgifter, ej jobbavdrag (032)'},
	{value: '35', text: 'Vissa inte skattepl. ersättning till utländska forskare (035)'},
	{value: '36', text: 'Ersättningar/förmåner för bostad och resa med SINK skatt (036)'},
	{value: '37', text: 'Vissa avdrag (037)'},
	{value: '39', text: 'Hyresersättning (039)'},
	{value: '41', text: 'Förmån, Bostad småhus (041)'},
	{value: '42', text: 'Förmån, Kost (042)'},
	{value: '43', text: 'Förmån, Bostad ej småhus (043)'},
	{value: '44', text: 'Förmån, Ränta (044)'},
	{value: '45', text: 'Förmån, Parkering (045)'},
	{value: '47', text: 'Förmån, Annan förmån (047)'},
	{value: '48', text: 'Förmån, har justerats (048)'},
	{value: '49', text: 'Förmån, som pension (049)'},
	{value: '50', text: 'Bilersättning enligt schablon (050)'},
	{value: '51', text: 'Traktamente inrikes enligt schablon (051)'},
	{value: '52', text: 'Traktamente utrikes enligt schablon (052)'},
	{value: '53', text: 'Inrikes tjänsteresa längre tid än tre månader (053)'},
	{value: '54', text: 'Utrikes tjänsteresa längre tid än tre månader (054)'},
	{value: '55', text: 'Kostnadsersättning Reskostnader (055)'},
	{value: '56', text: 'Kostnadsersättning Logi (056)'},
	{value: '98', text: 'Betalat för drivmedel vid bilförmån (098)'},
	{value: '105', text: 'Dagpenning vid tjänstgöring inom totalförsvaret (005 / 004)'},
	{value: '131', text: 'Kontant ersättning, fri från avgift (131)'},
	{value: '132', text: 'Förmåner utom bilförmån, fri från avgift (132)'},
	{value: '133', text: 'Bilförmån, fri från avgift (133)'},
	{value: '503', text: 'Ränteinkomst, ej konto (503 blankett KU20)'},
	{value: '540', text: 'Betald och för året avdragsgill ränta (540 blankett KU25)'},
	{value: '541', text: 'Förskottsränta som ingår i totalt inbetald ränta (541 blankett KU25)'},
	{value: '542', text: 'Ränteutgifter för lån med säkerhet (542 blankett KU25)'},
	{value: '545', text: 'Ränteutgifter för lån utan säkerhet (545 blankett KU25)'},
];

export const CoinsLonTyp = [
	{value: '000', text: 'Ej med'},
	{value: '029', text: '3-års snitt'},
	{value: '030', text: 'Månatliga tillägg - semestergrundande'},
	{value: '031', text: 'Månatliga tillägg - ej semestergrundande'},
	{value: '032', text: 'Årliga tillägg -  semestergrundande'},
	{value: '033', text: 'Årliga tillägg -  ej semestergrundande'},
	{value: '051', text: 'Jour/OB och beredskap'},
	{value: '052', text: 'Bonus; successivt 3-årssnitt'},
	{value: '053', text: 'Löneavstående belopp'},
	{value: '054', text: 'Övriga bruttoavdrag 1'},
	{value: '055', text: 'Övriga bruttoavdrag 2'},
	{value: '056', text: 'Övriga bruttoavdrag 3'},
	{value: '023', text: 'Frivillig grupplivförsäkring'},
	{value: '024', text: 'Tjänstledighet p.g.a. studier'},
	{value: '025', text: 'Tjänstledighet p.g.a. föräldraledighet'},
	{value: '026', text: 'Tjänstledighet p.g.a. militär tjänstgöring'},
	{value: '027', text: 'Tjänstledighet övrigt'},
	{value: '028', text: 'Sjukfrånvaro'},
];

export const LonStatistik = [
	{value: 'ARB', text: 'Arbetstid'},
	{value: 'ARBNOR', text: 'Arbetstid - Normal'},
	{value: 'ARBMER', text: 'Arbetstid - Mertid'},
	{value: 'ARBOVT', text: 'Arbetstid - Övertid'},
	{value: 'ARBRES', text: 'Arbetstid - Restid'},
	{value: 'ARBJOR', text: 'Arbetstid - Jourtid'},
	{value: 'ARBBER', text: 'Arbetstid - Beredskap'},
	{value: 'ARBTIL', text: 'Arbetstid - Lönetillägg'},
	{value: 'LON', text: 'Övrig lön'},
	{value: 'LONRET', text: 'Övrig lön - Retroaktiv'},
	{value: 'LONBON', text: 'Övrig lön - Bonus'},
	{value: 'LONÖVR', text: 'Övrig lön - Övrigt'},
	{value: 'FRM', text: 'Naturaförmån'},
	{value: 'FRMBIL', text: 'Naturaförmån - Bil'},
	{value: 'FRMMAT', text: 'Naturaförmån - Måltider'},
	{value: 'FRMHUS', text: 'Naturaförmån - Bostad'},
	{value: 'FRMRTA', text: 'Naturaförmån - Ränta'},
	{value: 'FRMÖVR', text: 'Naturaförmån - Övrigt'},
	{value: 'RES', text: 'Reseersättning'},
	{value: 'RESTRA', text: 'Reseersättning - Traktamenten'},
	{value: 'RESMAT', text: 'Reseersättning - Måltidsreduktion'},
	{value: 'RESMIL', text: 'Reseersättning - Milersättning'},
	{value: 'RESUTL', text: 'Reseersättning - Utlägg'},
	{value: 'NET', text: 'Nettolön'},
	{value: 'NETFOR', text: 'Nettolön - Förskott'},
	{value: 'NETAVD', text: 'Nettolön - Avdrag'},
	{value: 'NETFAK', text: 'Nettolön - Fackavgift'},
	{value: 'NETGRA', text: 'Nettolön - Granskningsavgift'},
	{value: 'NETFÖR', text: 'Nettolön - Gruppförsäkring'},
	{value: 'NETUTL', text: 'Nettolön - Utlägg'},
	{value: 'SJK', text: 'Sjukfrånvaro'},
	{value: 'SJKKAR', text: 'Sjukfrånvaro - Karens'},
	{value: 'SJKLON', text: 'Sjukfrånvaro - Sjuklön'},
	{value: 'SJKERS', text: 'Sjukfrånvaro - Sjukersättning'},
	{value: 'SJKPEN', text: 'Sjukfrånvaro - Sjukpenning'},
	{value: 'SJKTIL', text: 'Sjukfrånvaro - Lönetillägg'},
	{value: 'FRA', text: 'Frånvaro'},
	{value: 'FRAHAV', text: 'Frånvaro - Havandeskapspenning'},
	{value: 'FRAFPE', text: 'Frånvaro - Föräldrapenning'},
	{value: 'FRATFP', text: 'Frånvaro - Tillfällig föräldrapenning'},
	{value: 'FRAUTB', text: 'Frånvaro - Utbildning'},
	{value: 'FRAMIL', text: 'Frånvaro - Militärtjänst'},
	{value: 'FRATJT', text: 'Frånvaro - Tjänstledig'},
	{value: 'FRAÖVR', text: 'Frånvaro - Övrigt'},
	{value: 'SEM', text: 'Semester'},
	{value: 'SEMBET', text: 'Semester - Betald'},
	{value: 'SEMFOR', text: 'Semester - Förskott'},
	{value: 'SEMOBE', text: 'Semester - Obetald'},
	{value: 'SEMSPA', text: 'Semester - Sparad'},
	{value: 'SEMLÖN', text: 'Semester - Semesterlön'},
	{value: 'SEMERS', text: 'Semester - Semesterersättning'},
	{value: 'SEMFER', text: 'Semester - Ferielön'},
	{value: 'DIV', text: 'Diverse övrigt'},
];

export const SAFstatistik = [
	{value: '000', text: 'Ej med i SN statistiken'},
	{value: '051', text: 'Fast lön (10)'},
	{value: '058', text: 'Prestationslön (12)'},
	{value: '601', text: 'Summa tid-/prestationslön (13)'},
	{value: '052', text: 'Övertidstillägg (15a)'},
	{value: '053', text: 'Övertidsersättning (15b)'},
	{value: '054', text: 'OB-tillägg (16)'},
	{value: '056', text: 'Tillägg för speciella arbetsförhållanden (17)'},
	{value: '057', text: 'Andra förmåner (18)'},
	{value: '055', text: 'Andra ersättningar (18)'},
	{value: '800', text: 'Skiftformstillägg (19) (Stål- o Metallförbundet)'},
	{value: '801', text: 'Post- och ställningersättning (19) (Sågverksindustrin)'},
	// {value: '802', text: 'Kalvningstillägg (19) (Lantarbetare)'},
	{value: '816', text: 'Garantilön (19) (Bemanningsföretagen)'},
	{value: '817', text: 'Utbokad tid (21) (Bemanningsföretagen)'},
	{value: '805', text: 'Traktamente (21) (Sveriges Byggindustrier)'},
	{value: '806', text: 'Reskostnadsersättning (22) (Sveriges byggindustrier)'},
	{value: '808', text: 'Förrättningstillägg (23) (Sveriges Byggindustrier)'},
	{value: '813', text: 'Enkel OB (Biltrafikens arbetsgivarförbund)'},
	{value: '814', text: 'Kvalificerat OB (Biltrafikens arbetsgivarförbund)'},
	{value: '815', text: 'Skifttillägg (Biltrafiekns arbetsgivarförbund)'},
];

export const KFOstatistik = [
	{value: '000', text: 'Ej med i Fremia lönestatistik'},
	{value: '051', text: 'Överenskommen fast månads-, vecko-, eller timlön'},
	{value: '052', text: 'Tillägg vid mer- och övertid'},
	{value: '053', text: 'Ersättning vid mer- och övertid'},
	{value: '058', text: 'Rörlig lön'},
	{value: '601', text: 'Summa tid-/prestationslön'},
	{value: '054', text: 'Tillägg vid skift, OB, förskjuten arbetstid'},
	{value: '056', text: 'Tillägg för risk, smuts, värme m.m.'},
	{value: '055', text: 'Jour-, beredskaps-, vänte-, restidsersättning'},
	{value: '057', text: 'Därav förmåner'},
];

export const AGAStatistik = [
	{value: '000', text: 'Ej med i Arbetsgivaralliansen lönestatistik'},
	{value: '051', text: 'Överenskommen fast månads-, vecko-, eller timlön'},
	{value: '052', text: 'Tillägg vid mer- och övertid'},
	{value: '053', text: 'Ersättning vid mer- och övertid'},
	{value: '054', text: 'Rörliga tillägg'},
	{value: '058', text: 'Rörlig lön'},
	{value: '057', text: 'Skattepliktiga förmåner'},
	{value: '055', text: 'Andra förmåner och ersättningar'},
	{value: '001', text: 'Arbetad tid'},
];

export const SCBStatistik = [
	{value: '000', text: 'Ej med i SCB lönestrukturstatistiken'},
	{value: '051', text: 'Överenskommen fast månads-, vecko-, eller timlön (6)'},
	{value: '052', text: 'Tillägg vid mer- och övertid (10b)'},
	{value: '053', text: 'Ersättning vid mer- och övertid (10c)'},
	{value: '058', text: 'Rörlig lön (11)'},
	{value: '054', text: 'Tillägg vid skift, OB, förskjuten arbetstid (12)'},
	{value: '056', text: 'Tillägg för risk, smuts, värme m.m. (12)'},
	{value: '055', text: 'Jour-, beredskaps-, vänte-, restidsersättning (13)'},
	{value: '057', text: 'Därav förmåner (14) (ingår i 13)'},
];

export const SCBKonjunktur = [
	{value: '--', text: 'Ej med i SCB konjunkturstatistiken'},
	{value: '00', text: 'Endast grundande arbetad tid'},
	{value: '02', text: 'Överenskomma fasta tillägg (2)'},
	{value: '04', text: 'Summa rörliga tillägg exkl. jourersättning och naturaförmån (4)'},
	{value: '05', text: 'Därav övertidsttillägg (5) (ingår i rad 4)'},
	{value: '06', text: 'Utbetald lön (för arbetad tid) före skatteavdrag (6)'},
	{value: '07', text: 'Därav övertidstillägg (7) (ingår i rad 6)'},
	{value: '46', text: 'Rörligt tillägg (4) eller utbetald lön (6)'},
	{value: '57', text: 'Därav övertidstillägg (5 eller 7) (ingår i rad 4 eller 6)'},
	{value: '10', text: 'Retroaktiv lön utbetald under perioden (10)'},
	{value: '12', text: 'Rörligt tillägg avseende tidigare perioder (12)'},
	{value: '13', text: 'Sjuklön (13)'},
];

export const AntalEnhet = [
	{value: 'tim', text: 'timmar'},
	{value: 'mån', text: 'månad'},
	{value: 'dgr', text: 'arbetsdagar'},
	{value: 'vec', text: 'veckor'},
	{value: 'km', text: 'kilometer'},
	{value: 'mil', text: 'mil'},
	{value: 'st', text: 'stycken'},
	{value: 'min', text: 'minuter'},
	{value: 'kr', text: 'kronor'},
	{value: '%', text: 'procent'},
	{value: 'dag', text: 'kalenderdagar'},
];

export const SkrivExText = [
	{value: 'FL', text: 'Före löneart'},
	{value: 'EL', text: 'Efter löneart'},
	{value: 'IN', text: 'Intern notering'},
];

export const SemGrundTyp = [
	{value: 'A', text: 'Lön arbetad tid'},
	{value: 'R', text: 'Lön rörlig del'},
	{value: 'L', text: 'Lön övrigt'},
];

export const SemNarvTyp = [
	{value: 'ADD', text: 'Öka arbetad tid'},
	{value: 'SUB', text: 'Minska arbetad tid'},
];

export const SemFranTyp = [
	{value: 'SJK', text: 'Sjukfrånvaro'},
	{value: 'SMB', text: 'Smittbärare'},
	{value: 'ARB', text: 'Arbetsskada'},
	{value: 'REH', text: 'Rehabilitering'},
	{value: 'FLS', text: 'Föräldraledighet sammanboende'},
	{value: 'FLE', text: 'Föräldraledighet ensamstående'},
	{value: 'PAP', text: 'Pappaledig'},
	{value: 'KON', text: 'Kontaktdagar'},
	{value: 'HAV', text: 'Graviditetspenning'},
	{value: 'HAF', text: 'Graviditetspenning fosterskada'},
	{value: 'TFP', text: 'Tillfällig föräldrapeng'},
	{value: 'UTB', text: 'Utbildning med studiestöd'},
	{value: 'FAC', text: 'Facklig utbildning'},
	{value: 'MIL', text: 'Militär repitionsövning'},
	{value: 'SVE', text: 'Svenskundervisning för invandrare'},
	{value: 'NSV', text: 'Närståendevård'},
	{value: 'NSH', text: 'Närståendevård HIV-smittad'},
	{value: 'ÖVR', text: 'Annan semestergrundande frånvaro'},
	{value: 'TJL', text: 'Tjänstledighet hela dagar (ej sem.grund)'},
	{value: 'TJT', text: 'Tjänstledighet del av dag (ej sem.grund)'},
	{value: 'DIV', text: 'Annan frånvaro hela dagar (ej sem.grund)'},
	{value: 'DIT', text: 'Annan frånvaro del av dag (ej sem.grund)'},
];

export const SemUttagTyp = [
	{value: 'BET', text: 'Betalda dagar'},
	{value: 'OBE', text: 'Obetalda dagar'},
	{value: 'SPA', text: 'Sparade dagar'},
	{value: 'FÖR', text: 'Förskottsdagar'},
	{value: 'LÖN', text: 'Semesterlön i kr'},
	{value: 'TIL', text: 'Separat tillägg'},
	{value: 'ERS', text: 'Semesterersättning'},
	{value: 'NYA', text: 'Intjänade dagar'},
	{value: 'KON', text: 'Endast kontering'},
];

export const FerUttagTyp = [
	{value: 'MÅN', text: 'Månadslön'},
	{value: 'DAG', text: 'Ferielönsdag'},
	{value: 'RED', text: 'Avdrag ferielön'},
	{value: 'TIL', text: 'Semestertillägg'},
	{value: 'NYD', text: 'Intjänad ferielönsdag'},
	{value: 'NYT', text: 'Intjänat semestertillägg'},
];

export const UphUttagTyp = [
	{value: 'LON', text: 'Uppehållslön'},
	{value: 'TIL', text: 'Uppehållslönetillägg'},
	{value: 'NYL', text: 'Intjänad uppehållslön'},
	{value: 'NYT', text: 'Intjänat uppehållslönetillägg'},
];

export const ArbGivTidTyp = [
	{value: 'ARB', text: 'Arbetad tid'},
	{value: 'FRA', text: 'Frånvarotid'},
	{value: 'FRN', text: 'Frånvarotid, minskar närvaro'},
	{value: 'ÖTI', text: 'Övertid'},
	{value: 'MER', text: 'Mertid'},
];

export const ArbGivErsTyp = [
	{value: 'SJE', text: 'Sjuklön (utan timmar)'},
	{value: 'SJK', text: 'Sjuklön (med timmar)'},
	{value: 'BEE', text: 'Beredskap/Jour (utan timmar)'},
	{value: 'BER', text: 'Beredskap/Jour (med timmar)'},
	{value: 'OTE', text: 'Övertidstillägg'},
	{value: 'MER', text: 'Mertid'},
	{value: 'OBE', text: 'OB-tillägg'},
	{value: 'TIL', text: 'Lönetillägg'},
	{value: 'SEM', text: 'Semesterersättning'},
	{value: 'GAG', text: 'Gage /lön per uppdrag'},
	{value: 'OVR', text: 'Andra förmåner'},
];

export const LSSBeslut = [
	{value: 'AUT', text: 'Automatiskt val'},
	{value: 'FSK', text: 'Försäkringskassan'},
	{value: 'KOM', text: 'Kommun'},
	{value: 'TUT', text: 'Tillfälligt utökat'},
	{value: 'SJU', text: 'Sjuklön'},
];

export const LSSDagVerkTyp = [
	{value: 'DAG', text: 'Daglig verksamhet'},
	{value: 'OMS', text: 'Barnomsorg'},
	{value: 'SKO', text: 'Skola'},
];

export const LSSTimTyp = [
	{value: 'ASS', text: 'Assistans'},
	{value: 'JOR', text: 'Jour'},
	{value: 'BER', text: 'Beredskap'},
];

export const LosenLonTyp = [
	{value: 'MÅN', text: 'Månadslön'},
	{value: 'TIM', text: 'Timlön'},
	{value: 'PRE', text: 'Prestationslön'},
	{value: 'UTÖ', text: 'Utbetalt överskott'},
	{value: 'TIL', text: 'Lönetillägg'},
	{value: 'RTL', text: 'Rolltillägg (tid)'},
	{value: 'RTP', text: 'Rolltillägg (prestationslön)'},
	{value: 'AKT', text: 'Aktivitetstillägg (tid)'},
	{value: 'AKP', text: 'Aktivitetstillägg (prestationslön)'},
	{value: 'KPT', text: 'Kompetenstillägg (tid)'},
	{value: 'KPP', text: 'Kompetenstillägg (prestationslön)'},
	{value: 'AST', text: 'Ansvarstillägg (tid)'},
	{value: 'ASP', text: 'Ansvarstillägg (prestationslön)'},
	{value: 'AVD', text: 'Löneavdrag'},
	{value: 'OBT', text: 'OB-tillägg'},
	{value: 'ÖVT', text: 'Övertidstillägg'},
];

export const KompFlexsaldoTyp = [
	{value: '+', text: 'Ökar saldot'},
	{value: '-', text: 'Minskar saldot'},
];

export const KompsaldoTyp = [
	{value: '+', text: 'Ökar kompsaldot'},
	{value: '-', text: 'Minskar kompsaldot'},
];

export const LSSKollAvtal = [
	{value: 'KFO', text: 'Fremia'},
	{value: 'KFS', text: 'KFS'},
	{value: 'HÖK', text: 'HÖK/AB (SKL)'},
	{value: 'PAN', text: 'PAN (SKL)'},
	{value: 'VFG', text: 'Vårdföretagarna, bransch G'},
	{value: 'EGT', text: 'Annat'},
	{value: 'NEJ', text: 'Inget kollektivavtal'},
];

export const BankNamn = [
	{value: 'ISO', text: 'ISO 20022'},
	{value: 'BGC', text: 'Bankgirot KI'},
	{value: 'HBK', text: 'Handelsbanken Löner'},
	{value: 'BGL', text: 'Bankgirot LB'},
	{value: 'HBL', text: 'Handelsbanken LB'},
	{value: 'SEB', text: 'S E B (gammal)'},
	{value: 'FSB', text: 'Swedbank (gammal)'},
	{value: 'SBB', text: 'Swedbank Bas'},
	{value: 'SBI', text: 'Swedbank Bas (internationell)'},
	{value: 'SBU', text: 'Swedbank företaget registerhållare'},
	{value: 'SFI', text: 'Swedbank företaget registerhållare (internationell)'},
	{value: 'MNB', text: 'Nordea (gammal)'},
	{value: 'NLU', text: 'Nordea'},
];

export const BokfProg = [
	{value: 'SIE4', text: 'SIE/4 fil'},
	{value: 'FNX', text: 'Fortnox Bokföring'},
	{value: 'BRX', text: 'Briox Bokföring'},
	{value: 'PROC', text: 'Procountor Bokföring'},
	{value: 'VEAC', text: 'Spiris'},
	{value: 'FLAT', text: 'Textfil'},
	{value: 'SAP4', text: 'SAP Business One'},
	{value: 'MAGB', text: 'Magenta Bokföring'},
	{value: 'CORB', text: 'Corbis'},
	{value: 'EDIS', text: 'Edison'},
	{value: 'SE1P', text: 'SAP E1P'},
	{value: 'FRID', text: 'FRIDA'},
];

export const AmfTyp = [
	{value: '-', text: 'Ingår ej i rapportering'},
	{value: 'A', text: 'Arbetare'},
	{value: 'A51', text: 'Teknikavtalet IF Metall'},
	{value: 'A52', text: 'TEKO avtalet'},
	{value: 'A53', text: 'Livsmedelsavtalet'},
	{value: 'A54', text: 'Tobaksavtalet'},
	{value: 'A55', text: 'Avtalet för vin- och spritindustrin'},
	{value: 'A56', text: 'Kafferosterier och kryddfabriker'},
	{value: 'A57', text: 'Byggnadsämnesindustri'},
	{value: 'A58', text: 'Buteljglasindustrin'},
	{value: 'A59', text: 'Motorbranchavtalet'},
	{value: 'A60', text: 'Industriavtalet'},
	{value: 'A61', text: 'Läder & Sportartiklar'},
	{value: 'A62', text: 'Kemiska fabriker'},
	{value: 'A63', text: 'Glasindustrin'},
	{value: 'A64', text: 'Gemensamma Metall'},
	{value: 'A65', text: 'Explosivämnesindustrin'},
	{value: 'A66', text: 'I-avtalet (Allokemisk industri)'},
	{value: 'A67', text: 'Återvinningsföretag'},
	{value: 'A68', text: 'Tvättindustrin'},
	{value: 'A69', text: 'Stenindustrin'},
	{value: 'A70', text: 'Oljeraffinaderier'},
	{value: 'A71', text: 'Sockerindustrin (Nordic Sugar AB)'},
	{value: 'A72', text: 'IMG-avtalet'},
	{value: 'A73', text: 'Sågverksavtalet'},
	{value: 'A74', text: 'Skogsavtalet'},
	{value: 'A75', text: 'Virkesmätning'},
	{value: 'A76', text: 'Stoppmöbelindustrin'},
	{value: 'A77', text: 'Träindustri'},
	{value: 'A78', text: 'Infomediaavtalet'},
	{value: 'A79', text: 'Förpackningsavtalet'},
	{value: 'A80', text: 'Ahlsell Gelia/Sv. Foder/Teknosan'},
	{value: 'A81', text: 'Handels- & Metallavtalet'},
	{value: 'A82', text: 'Studsviksavtalet'},
	{value: 'A83', text: 'Flygtekniker med typcertifikat (medarbetaravtal)'},
	{value: 'A84', text: 'Massa- och pappersindustrin'},
	{value: 'A85', text: 'Stål- och metallindustrin blå avtalet'},
	{value: 'A86', text: 'Tidningsavtalet'},
	{value: 'A87', text: 'Gruventreprenadavtalet'},
	{value: 'A88', text: 'Trävaruhandelsavtalet'},
	{value: 'A3', text: 'Måleriyrket'},
	{value: 'A91', text: 'Installationsavtalet'},
	{value: 'A92', text: 'Kraftverksavtalet'},
	{value: 'A93', text: 'Elektroskandiaavtalet'},
	{value: 'A11', text: 'Bemanningsföretag'},
	{value: 'A12', text: 'Byggavtalet'},
	{value: 'A13', text: 'Dalslands kanal'},
	{value: 'A14', text: 'Detaljhandeln'},
	{value: 'A15', text: 'Entreprenadmaskinavtalet'},
	{value: 'A16', text: 'Glasmästeriavtalet'},
	{value: 'A17', text: 'Göta kanalbolag AB'},
	{value: 'A18', text: 'Lageravtalet'},
	{value: 'A19', text: 'Lager- och E-handelsavtalet'},
	{value: 'A20', text: 'Lagerpersonal vid glassföretag, filialer och depålager samt direktsäljer'},
	{value: 'A21', text: 'Larm- och säkerhetsteknikavtalet'},
	{value: 'A22', text: 'Maskinföraravtalet'},
	{value: 'A23', text: 'Plåt- och ventilationsavtalet'},
	{value: 'A24', text: 'Privatteateravtalet (medarbetaravtal)'},
	{value: 'A25', text: 'Städavtalet'},
	{value: 'A26', text: 'Teknikinstallation VVS och Kyl'},
	{value: 'A41', text: 'TRIA Skola & Vård'},
	{value: 'A27', text: 'Restaurang- och caféanställda'},
	{value: 'A28', text: 'Skärgårdstrafik ASL'},
	{value: 'A42', text: 'STANLEY Security'},
	{value: 'A29', text: 'Värdepapper'},
	{value: 'A30', text: 'Väg- och banavtalet'},
	{value: 'A43', text: 'Danscentrumavtalet'},
	{value: 'A44', text: 'Teatercentrumavtalet'},
	{value: 'A45', text: 'Kollektivavtalet för Radio-, TV-, Data- och Elektroniktekniker'},
	{value: 'A46', text: 'Spårtrafik'},
	{value: 'T', text: 'Tjänsteman'},
	{value: 'T6', text: 'Tjänsteman, Anställd VD'},
];

export const AmfTR = [
	{value: 'TRR', text: 'TRR'},
	{value: 'TRS', text: 'TRS'},
	{value: 'NEJ', text: 'Inget'},
];

export const BilBiltyp = [
	{value: 'BEN', text: 'Bensin'},
	{value: 'DIS', text: 'Diesel'},
	{value: 'EL', text: 'El'},
	{value: 'GAS', text: 'Gas'},
	{value: 'LPG', text: 'Gasol'},
	{value: 'ALK', text: 'Alkohol'},
	{value: 'HYB', text: 'Elhybrid'},
	{value: 'OVR', text: 'Övrigt'},
];

export const Roll = [
	{value: 'ADM', text: 'Systemadministratör'},
	{value: 'FTG', text: 'Företagsadministratör'},
	{value: 'AVD', text: 'Avdelningsadministratör'},
	{value: 'LSS', text: 'Kundansvarig'},
	{value: 'BRU', text: 'Brukare'},
	{value: 'PER', text: 'Anställd'},
];

export const LoginType = [
	{value: 'F', text: 'Enligt företagets inställningar'},
	{value: 'S', text: 'Tvåstegsverifering (SMS)'},
	{value: 'E', text: 'E-legitimation'},
	{value: 'A', text: 'Användarnamn & lösenord'},
];

export const KalKarensRegel = [
	{value: 'KAR', text: 'Karenstimmar'},
	{value: 'KFO', text: 'Fremia'},
	{value: 'LSS', text: 'Vårdföretagarna'},
];

export const SjukFranvaroTyp = [
	{value: 'K', text: 'Karensdag'},
	{value: 'L', text: 'Sjuklön'},
	{value: 'E', text: 'Sjukersättning'},
	{value: 'P', text: 'Sjukpenning'},
];

export const SafLonForm = [
	{value: '1', text: 'Månadslön'},
	{value: '2', text: 'Veckolön'},
	{value: '3', text: 'Timlön'},
];

export const SafArbTidsart = [
	{value: '1', text: '1 - Dagarbete'},
	{value: '2', text: '2 - 2-skiftsarbete'},
	{value: '3', text: '3 - Intermittent 3-skiftsarbete'},
	{value: '4', text: '4 - Kontinuerligt 3-skiftsarbete'},
	{value: '5', text: '5 - Underjordsarbete'},
	{value: '6', text: '6 - Ständigt nattskift'},
	{value: '7', text: '7 - Övrigt'},
];

export const SafPersKat = [
	{value: '1', text: 'Arbetare'},
	{value: '2', text: 'Intern tjänsteman'},
	{value: '3', text: 'Entrepenadtjänsteman alternativt projektkonsult'},
	{value: '4', text: 'Uppdragskonsult (tjänsteman, garantilön 133 timmar)'},
	{value: '5', text: 'Uppdragskonsult (tjänsteman, garantilön 150 timmar)'},
	{value: '6', text: 'Uppdragskonsult (tjänsteman)'},
]

export const HandelseTyp = [
	{value: 'AV', text: 'Avanmälan'},
	{value: 'NY', text: 'Nyanmälan'},
];

export const HandelseKod = [
	{value: 0, text: ''},
	{value: 1, text: 'Avslutad anställning'},
	{value: 2, text: 'Föräldraledig'},
	// {value: 3, text: 'Tjänstledig'},
	{value: 9, text: 'Annulering'},
];

export const ITPPlan = [
	{value: 'AUTO', text: 'Automatiskt beroende på ålder'},
	{value: 'ITP1', text: 'ITP 1 - premiebestämd'},
	{value: 'ITP2', text: 'ITP 2 - förmånsbestämd'},
	{value: 'NONE', text: 'Ej ITP'},
];

export const ITP2ArbOformaga = [
	{value: '0.75', text: '75%'},
	{value: '0.5', text: '50%'},
	{value: '0.25', text: '25%'},
	{value: '0.0', text: '0%'},
];

export const Dimensioner = [
	{value: '1', text: '1 - Kostnadsställe'},
	{value: '2', text: '2 - Kostnadsbärare'},
	{value: '3', text: '3 - Reserv'},
	{value: '4', text: '4 - Reserv'},
	{value: '5', text: '5 - Reserv'},
	{value: '6', text: '6 - Projekt'},
	{value: '7', text: '7 - Anställningsnummer'},
	{value: '8', text: '8 - Kund'},
	{value: '9', text: '9 - Leverantör'},
	{value: '10', text: '10 - Faktura'},
	{value: '11', text: '11 - Reserv'},
	{value: '12', text: '12 - Reserv'},
	{value: '13', text: '13 - Reserv'},
	{value: '14', text: '14 - Reserv'},
	{value: '15', text: '15 - Reserv'},
	{value: '16', text: '16 - Reserv'},
	{value: '17', text: '17 - Reserv'},
	{value: '18', text: '18 - Reserv'},
	{value: '19', text: '19 - Reserv'},
];

export const DimensionerSFSP = [
	{value: '1', text: '1 - Kostnadsställe'},
	{value: '2', text: '2 - Projektkod'},
	{value: '3', text: '3 - Produktkod'},
	{value: '4', text: '4 - Aktivitet'},
	{value: '5', text: '5 - Free2'},
];

export const DimensionerFRID = [
	{value: '1', text: '1 - Kostnadsställe'},
	{value: '2', text: '2 - Aktivitet'},
	{value: '3', text: '3 - Finansiär'},
	{value: '4', text: '4 - Resultatkod'},
	{value: '5', text: '5 - Avdelning'},
	{value: '6', text: '6 - K/I-grupp'},
];

export const SafJobbstatus = [
	{value: '0', text: 'Övriga anställda'},
	{value: '1', text: 'Chef'},
	{value: '2', text: 'VD'},
	{value: '3', text: 'Arbetsledare'},
	{value: '4', text: 'Förman'},
	{value: '5', text: 'Lärling'},
];

export const SorteringPersonallista = [
	{value: 'AnstNr', text: 'Anställningsnummer'},
	{value: 'EfNamnFoNamn', text: 'Efternamn, Förnamn'},
	{value: 'FoNamnEfNamn', text: 'Förnamn, Efternamn'},
	{value: 'PersNr', text: 'Personnummer'},
];

export const SemDagarTyp = [
	{value: 'NET', text: 'Nettodagar'},
	{value: 'BRU', text: 'Semesterfaktor'},
	{value: 'TIM', text: 'Timsemester'},
];

export const SemUndTyp = [
	{value: 'INTJ', text: 'Tider och ersättningar från intjänandeperiod', visible: true},
	{value: 'LONUTB', text: 'Tider från intjänandeperiod, ersättningar från utbetalningsdatum', visible: true},
	{value: 'KONTAN', text: 'Kontantprincipen', visible: true},
].filter((item) => item.visible);

export const SemTidsEnhet = [
	{value: 'DGR', text: 'Dagar'},
	{value: 'TIM', text: 'Timmar'},
];

export const SemGruSjukdom = [
	{value: 'LAG', text: 'Enligt lag'},
	{value: 'DEL', text: 'Enligt lag samt deltid'},
	{value: 'ALL', text: 'All sjukfrånvaro'},
];

export const BokfdatLon = [
	{value: 'U', text: 'Utbetalningsdatum'},
	{value: 'E', text: 'Intjänandeperioden'},
];

export const BokfdatSkatt = [
	{value: 'L', text: 'Löneperioden'},
	{value: 'S', text: 'Skattedatum'},
];

export const PerKontaktRelation = [
	{value: 'BARN', text: 'Barn'},
	{value: 'PARTNER', text: 'Partner'},
	{value: 'FÖRÄLDER', text: 'Förälder'},
	{value: 'SYSKON', text: 'Syskon'},
	{value: 'SLÄKT', text: 'Släkting'},
	{value: 'ANNAN', text: 'Annan'},
];

export const SlutatOrsak = [
	{value: 'ARB', text: 'Uppsägning p.g.a arbetsbrist'},
	{value: 'TID', text: 'Avslutad tidsbegränsad anställning'},
	{value: 'BEG', text: 'Den anställdes egen begäran'},
	{value: 'KON', text: 'Konkurs'},
	{value: 'PER', text: 'Annan orsak'},
];

export const KostnSlag = [
	{value: 'KRI', text: 'Kringkostnader'},
	{value: 'KVA', text: 'Kvarstående medel'},
	{value: 'ADM', text: 'Administration'},
	{value: 'UTB', text: 'Utbildningskostnader'},
	{value: 'AMI', text: 'Arbetsmiljöinsatser'},
	{value: 'PER', text: 'Personalomkostnader'},
	{value: 'ASS', text: 'Assistansomkostnader'},
	{value: 'LÖN', text: 'Lönekostnader'},
];

export const CadmTyp = [
	{value: 'KRONOR', text: 'Kronor'},
	{value: 'PRCSCH', text: 'Procent av schablonbelopp'},
	{value: 'PRCBEV', text: 'Procent av beviljat belopp'},
];

export const Sjklonkostn = [
	{value: 'NOCADM', text: 'Utan administration'},
	{value: 'SCHABL', text: 'Schablonbelopp'},
	{value: 'TOTALT', text: 'Total kostnad'},
];

export const Uskr3057Selection = [
	{value: 'VRD', text: 'Vårdnadshavare'},
	{value: 'GOD', text: 'God man'},
	{value: 'FRV', text: 'Förvaltare'},
];

export const FKKoptAterbet = [
	{value: 'DRA', text: 'Försäkringskassan drar av för mycket utbetald ersättning'},
	{value: 'PRV', text: 'Försäkringskassan prövar om jag är återbetalningsskyldig'},
];

export const ArbAvgUts = [
	{value: '1A1B', text: 'till Kanada, USA, Indien, Sydkorea (1)'},
	{value: '1C1D', text: 'till Québec, Filippinerna (1)'},
	{value: '2A2B', text: 'från USA, Kanada, Sydkorea (2 sv.utbet)'},
	{value: '2C2D', text: 'från Québec (2 sv.utbet)'},
	{value: '3A3B', text: 'från Kanada, USA, Indien, Sydkorea (3)'},
	{value: '3C3D', text: 'från Québec, Filippinerna (3)'},
	{value: '4A4B', text: 'till Kanada, Sydkorea (4 sv.koncern)'},
	{value: '4C4D', text: 'till Québec (4 sv.koncern)'},
];

export const StdPayslipLocale = [
	{value: 'SV', text: 'Svenska'},
	{value: 'EN', text: 'Engelska'},
	{value: 'FR', text: 'Franska'},
	{value: 'PL', text: 'Polska'},
];

export const GenderOptions = [
	{value: 'M', text: 'Man'},
	{value: 'F', text: 'Kvinna'},
	{value: 'U', text: 'Ospecificerat'},
];

export const ITPForlangdTyp = [
	{value: 'NEJ', text: 'Ingen ITP efter 65 år'},
	{value: 'E65', text: 'ITP 1 efter 65 år'},
	{value: 'E66', text: 'ITP 1 efter 66 år'},
];

export const KUBlankett = [
	{value: 'KU10S', text: 'KU10 - Kontrolluppgift från arbetsgivare m.fl.'},
	{value: 'KU10E', text: 'KU10 - Income statement from employers etc.'},
	{value: 'KU13S', text: 'KU13 - Särskild inkomstskatt för utomlands bosatta (SINK)'},
	{value: 'KU13E', text: 'KU13 - Special income tax for non-residents (SINK)'},
	{value: 'KU14S', text: 'KU14 - Pensionsgrundande inkomst och utbyte av kontrolluppgifter'},
	{value: 'KU14E', text: 'KU14 - Pensionable income and exchange of income statements'},
];

export const ForaReportType = [
	{value: 'MONTHLY', text: 'Månadsrapportering'},
	{value: 'YEARLY', text: 'Årsredovisning'},
	{value: 'NONE', text: 'Ej tecknad'},
];

export const ForaAvailableParameters = [
	{value: 'TILLVAL_ASL65', text: 'Avtalspension SAF-LO 65+'},
	{value: 'TILLVAL_KP65', text: 'Kompletterande Pension 65+'},
];

export const FerAvtalKod = [
	{value: 'KFO', text: 'Ferielön enligt Fremia'},
	{value: 'ALM', text: 'Almega friskoleavtal'},
];

export const BrukareNamnTyp = [
	{value: 'BRUKARE', text: 'Brukare'},
	{value: 'ARBETSLEDARE', text: 'Arbetsledare'},
	{value: 'KUND', text: 'Kund'},
];

export const SKVLandskoder = [
	{
		'value': 'AF',
		'text':  'Afghanistan',
	},
	{
		'value': 'AL',
		'text':  'Albanien',
	},
	{
		'value': 'DZ',
		'text':  'Algeriet',
	},
	{
		'value': 'AS',
		'text':  'Amerikanska Samoa',
	},
	{
		'value': 'AD',
		'text':  'Andorra',
	},
	{
		'value': 'AO',
		'text':  'Angola',
	},
	{
		'value': 'AI',
		'text':  'Anguilla',
	},
	{
		'value': 'AQ',
		'text':  'Antarktis',
	},
	{
		'value': 'AG',
		'text':  'Antigua och Barbuda',
	},
	{
		'value': 'AR',
		'text':  'Argentina',
	},
	{
		'value': 'AM',
		'text':  'Armenien',
	},
	{
		'value': 'AW',
		'text':  'Aruba',
	},
	{
		'value': 'AU',
		'text':  'Australien',
	},
	{
		'value': 'AZ',
		'text':  'Azerbajdzjan',
	},
	{
		'value': 'BS',
		'text':  'Bahamas',
	},
	{
		'value': 'BH',
		'text':  'Bahrain',
	},
	{
		'value': 'BD',
		'text':  'Bangladesh',
	},
	{
		'value': 'BB',
		'text':  'Barbados',
	},
	{
		'value': 'BY',
		'text':  'Belarus/Vitryssland',
	},
	{
		'value': 'BE',
		'text':  'Belgien',
	},
	{
		'value': 'BZ',
		'text':  'Belize',
	},
	{
		'value': 'BJ',
		'text':  'Benin',
	},
	{
		'value': 'BM',
		'text':  'Bermuda',
	},
	{
		'value': 'BT',
		'text':  'Bhutan',
	},
	{
		'value': 'BO',
		'text':  'Bolivia',
	},
	{
		'value': 'BQ',
		'text':  'Bonaire, Sint Eustatius och Saba',
	},
	{
		'value': 'BA',
		'text':  'Bosnien och Hercegovina',
	},
	{
		'value': 'BW',
		'text':  'Botswana',
	},
	{
		'value': 'BV',
		'text':  'Bouvetön',
	},
	{
		'value': 'BR',
		'text':  'Brasilien',
	},
	{
		'value': 'IO',
		'text':  'Brittiska Indiska Oceanöarna',
	},
	{
		'value': 'BN',
		'text':  'Brunei Darussalam',
	},
	{
		'value': 'BG',
		'text':  'Bulgarien',
	},
	{
		'value': 'BF',
		'text':  'Burkina Faso',
	},
	{
		'value': 'BI',
		'text':  'Burundi',
	},
	{
		'value': 'KY',
		'text':  'Caymanöarna',
	},
	{
		'value': 'CF',
		'text':  'Centralafrikanska republiken',
	},
	{
		'value': 'CL',
		'text':  'Chile',
	},
	{
		'value': 'CO',
		'text':  'Colombia',
	},
	{
		'value': 'CK',
		'text':  'Cooköarna',
	},
	{
		'value': 'CR',
		'text':  'Costa Rica',
	},
	{
		'value': 'CW',
		'text':  'Curacao',
	},
	{
		'value': 'CY',
		'text':  'Cypern',
	},
	{
		'value': 'DK',
		'text':  'Danmark',
	},
	{
		'value': 'DJ',
		'text':  'Djibouti',
	},
	{
		'value': 'DM',
		'text':  'Dominica',
	},
	{
		'value': 'DO',
		'text':  'Dominikanska republiken',
	},
	{
		'value': 'EC',
		'text':  'Ecuador',
	},
	{
		'value': 'EG',
		'text':  'Egypten',
	},
	{
		'value': 'GQ',
		'text':  'Ekvatorialguinea',
	},
	{
		'value': 'SV',
		'text':  'El Salvador',
	},
	{
		'value': 'CI',
		'text':  'Elfenbenskusten',
	},
	{
		'value': 'ER',
		'text':  'Eritrea',
	},
	{
		'value': 'EE',
		'text':  'Estland',
	},
	{
		'value': 'SZ',
		'text':  'Eswatini/Swaziland',
	},
	{
		'value': 'ET',
		'text':  'Etiopien',
	},
	{
		'value': 'FK',
		'text':  'Falklandsöarna',
	},
	{
		'value': 'FJ',
		'text':  'Fiji',
	},
	{
		'value': 'PH',
		'text':  'Filippinerna',
	},
	{
		'value': 'FI',
		'text':  'Finland',
	},
	{
		'value': 'FR',
		'text':  'Frankrike',
	},
	{
		'value': 'GF',
		'text':  'Franska Guyana',
	},
	{
		'value': 'PF',
		'text':  'Franska Polynesien',
	},
	{
		'value': 'TF',
		'text':  'Franska Södra territorierna',
	},
	{
		'value': 'FO',
		'text':  'Färöarna',
	},
	{
		'value': 'AE',
		'text':  'Förenade Arabemiraten',
	},
	{
		'value': 'GA',
		'text':  'Gabon',
	},
	{
		'value': 'GM',
		'text':  'Gambia',
	},
	{
		'value': 'GE',
		'text':  'Georgien',
	},
	{
		'value': 'GH',
		'text':  'Ghana',
	},
	{
		'value': 'GI',
		'text':  'Gibraltar',
	},
	{
		'value': 'GR',
		'text':  'Grekland',
	},
	{
		'value': 'GD',
		'text':  'Grenada',
	},
	{
		'value': 'GL',
		'text':  'Grönland',
	},
	{
		'value': 'GP',
		'text':  'Guadeloupe',
	},
	{
		'value': 'GU',
		'text':  'Guam',
	},
	{
		'value': 'GT',
		'text':  'Guatemala',
	},
	{
		'value': 'GG',
		'text':  'Guernsey',
	},
	{
		'value': 'GN',
		'text':  'Guinea, Republiken',
	},
	{
		'value': 'GW',
		'text':  'Guinea-Bissau',
	},
	{
		'value': 'GY',
		'text':  'Guyana',
	},
	{
		'value': 'HT',
		'text':  'Haiti',
	},
	{
		'value': 'HM',
		'text':  'Heardön och McDonaldöarna',
	},
	{
		'value': 'HN',
		'text':  'Honduras',
	},
	{
		'value': 'HK',
		'text':  'Hongkong',
	},
	{
		'value': 'IN',
		'text':  'Indien',
	},
	{
		'value': 'ID',
		'text':  'Indonesien',
	},
	{
		'value': 'IQ',
		'text':  'Irak',
	},
	{
		'value': 'IR',
		'text':  'Iran',
	},
	{
		'value': 'IE',
		'text':  'Irland, Eire',
	},
	{
		'value': 'IS',
		'text':  'Island',
	},
	{
		'value': 'IM',
		'text':  'Isle of Man',
	},
	{
		'value': 'IL',
		'text':  'Israel',
	},
	{
		'value': 'IT',
		'text':  'Italien',
	},
	{
		'value': 'JM',
		'text':  'Jamaica',
	},
	{
		'value': 'JP',
		'text':  'Japan',
	},
	{
		'value': 'YE',
		'text':  'Jemen',
	},
	{
		'value': 'JE',
		'text':  'Jersey',
	},
	{
		'value': 'JO',
		'text':  'Jordanien',
	},
	{
		'value': 'CX',
		'text':  'Julön',
	},
	{
		'value': 'VI',
		'text':  'Jungfruöarna',
	},
	{
		'value': 'VG',
		'text':  'Jungfruöarna, Brittiska',
	},
	{
		'value': 'KH',
		'text':  'Kambodja',
	},
	{
		'value': 'CM',
		'text':  'Kamerun',
	},
	{
		'value': 'CA',
		'text':  'Kanada',
	},
	{
		'value': 'CV',
		'text':  'Kap Verde',
	},
	{
		'value': 'KZ',
		'text':  'Kazakstan',
	},
	{
		'value': 'KE',
		'text':  'Kenya',
	},
	{
		'value': 'CN',
		'text':  'Kina',
	},
	{
		'value': 'KG',
		'text':  'Kirgizistan',
	},
	{
		'value': 'KI',
		'text':  'Kiribati',
	},
	{
		'value': 'CC',
		'text':  'Kokosöarna',
	},
	{
		'value': 'KM',
		'text':  'Komorerna',
	},
	{
		'value': 'CG',
		'text':  'Kongo',
	},
	{
		'value': 'CD',
		'text':  'Kongo, Demokratiska republiken',
	},
	{
		'value': 'HR',
		'text':  'Kroatien',
	},
	{
		'value': 'CU',
		'text':  'Kuba',
	},
	{
		'value': 'KW',
		'text':  'Kuwait',
	},
	{
		'value': 'LA',
		'text':  'Laos',
	},
	{
		'value': 'LS',
		'text':  'Lesotho',
	},
	{
		'value': 'LV',
		'text':  'Lettland',
	},
	{
		'value': 'LB',
		'text':  'Libanon',
	},
	{
		'value': 'LR',
		'text':  'Liberia',
	},
	{
		'value': 'LY',
		'text':  'Libyen',
	},
	{
		'value': 'LI',
		'text':  'Liechtenstein',
	},
	{
		'value': 'LT',
		'text':  'Litauen',
	},
	{
		'value': 'LU',
		'text':  'Luxemborg',
	},
	{
		'value': 'MO',
		'text':  'Macao',
	},
	{
		'value': 'MG',
		'text':  'Madagaskar',
	},
	{
		'value': 'MW',
		'text':  'Malawi',
	},
	{
		'value': 'MY',
		'text':  'Malaysia',
	},
	{
		'value': 'MV',
		'text':  'Maldiverna',
	},
	{
		'value': 'ML',
		'text':  'Mali',
	},
	{
		'value': 'MT',
		'text':  'Malta',
	},
	{
		'value': 'MA',
		'text':  'Marocko',
	},
	{
		'value': 'MH',
		'text':  'Marshallöarna',
	},
	{
		'value': 'MQ',
		'text':  'Martinique',
	},
	{
		'value': 'MR',
		'text':  'Mauretanien',
	},
	{
		'value': 'MU',
		'text':  'Mauritius',
	},
	{
		'value': 'YT',
		'text':  'Mayotte',
	},
	{
		'value': 'MX',
		'text':  'Mexico',
	},
	{
		'value': 'FM',
		'text':  'Mikronesien',
	},
	{
		'value': 'MZ',
		'text':  'Moçambique',
	},
	{
		'value': 'MD',
		'text':  'Moldavien',
	},
	{
		'value': 'MC',
		'text':  'Monaco',
	},
	{
		'value': 'MN',
		'text':  'Mongoliet',
	},
	{
		'value': 'ME',
		'text':  'Montenegro',
	},
	{
		'value': 'MS',
		'text':  'Montserrat',
	},
	{
		'value': 'MM',
		'text':  'Myanmar/Burma',
	},
	{
		'value': 'NA',
		'text':  'Namibia',
	},
	{
		'value': 'NR',
		'text':  'Nauru',
	},
	{
		'value': 'NL',
		'text':  'Nederländerna/Holland',
	},
	{
		'value': 'NP',
		'text':  'Nepal',
	},
	{
		'value': 'NI',
		'text':  'Nicaragua',
	},
	{
		'value': 'NE',
		'text':  'Niger',
	},
	{
		'value': 'NG',
		'text':  'Nigeria',
	},
	{
		'value': 'NU',
		'text':  'Niue',
	},
	{
		'value': 'KP',
		'text':  'Nordkorea',
	},
	{
		'value': 'MK',
		'text':  'Nordmakedonien',
	},
	{
		'value': 'MP',
		'text':  'Nordmarianerna',
	},
	{
		'value': 'NF',
		'text':  'Norfolkön',
	},
	{
		'value': 'NO',
		'text':  'Norge',
	},
	{
		'value': 'NC',
		'text':  'Nya Kaledonien',
	},
	{
		'value': 'NZ',
		'text':  'Nya Zeeland',
	},
	{
		'value': 'OM',
		'text':  'Oman',
	},
	{
		'value': 'PK',
		'text':  'Pakistan',
	},
	{
		'value': 'PW',
		'text':  'Palau',
	},
	{
		'value': 'PS',
		'text':  'Palestina',
	},
	{
		'value': 'PA',
		'text':  'Panama',
	},
	{
		'value': 'PG',
		'text':  'Papua Nya Guinea',
	},
	{
		'value': 'PY',
		'text':  'Paraguay',
	},
	{
		'value': 'PE',
		'text':  'Peru',
	},
	{
		'value': 'PN',
		'text':  'Pitcairn',
	},
	{
		'value': 'PL',
		'text':  'Polen',
	},
	{
		'value': 'PT',
		'text':  'Portugal',
	},
	{
		'value': 'PR',
		'text':  'Puerto Rico',
	},
	{
		'value': 'QA',
		'text':  'Qatar',
	},
	{
		'value': 'RE',
		'text':  'Reunion',
	},
	{
		'value': 'RO',
		'text':  'Rumänien',
	},
	{
		'value': 'RW',
		'text':  'Rwanda',
	},
	{
		'value': 'RU',
		'text':  'Ryssland',
	},
	{
		'value': 'BL',
		'text':  'Saint Barthélemy',
	},
	{
		'value': 'SH',
		'text':  'Saint Helena',
	},
	{
		'value': 'KN',
		'text':  'Saint Kitts och Nevis',
	},
	{
		'value': 'LC',
		'text':  'Saint Lucia',
	},
	{
		'value': 'MF',
		'text':  'Saint Martin',
	},
	{
		'value': 'PM',
		'text':  'Saint Pierre och Miquelon',
	},
	{
		'value': 'VC',
		'text':  'Saint Vincent och Grenadinerna',
	},
	{
		'value': 'SB',
		'text':  'Salomonöarna',
	},
	{
		'value': 'WS',
		'text':  'Samoa',
	},
	{
		'value': 'SM',
		'text':  'San Marino',
	},
	{
		'value': 'ST',
		'text':  'São Tomé och Principe',
	},
	{
		'value': 'SA',
		'text':  'Saudiarabien',
	},
	{
		'value': 'CH',
		'text':  'Schweiz',
	},
	{
		'value': 'SN',
		'text':  'Senegal',
	},
	{
		'value': 'RS',
		'text':  'Serbien',
	},
	{
		'value': 'SC',
		'text':  'Seychellerna',
	},
	{
		'value': 'SL',
		'text':  'Sierra Leone',
	},
	{
		'value': 'SG',
		'text':  'Singapore',
	},
	{
		'value': 'SX',
		'text':  'Sint Maarten',
	},
	{
		'value': 'SK',
		'text':  'Slovakien',
	},
	{
		'value': 'SI',
		'text':  'Slovenien',
	},
	{
		'value': 'UM',
		'text':  'Små avlägset belägna öar',
	},
	{
		'value': 'SO',
		'text':  'Somalia',
	},
	{
		'value': 'ES',
		'text':  'Spanien',
	},
	{
		'value': 'LK',
		'text':  'Sri Lanka',
	},
	{
		'value': 'GB',
		'text':  'Storbritannien och Nordirland',
	},
	{
		'value': 'SD',
		'text':  'Sudan',
	},
	{
		'value': 'SR',
		'text':  'Surinam',
	},
	{
		'value': 'SJ',
		'text':  'Svalbard och Jan Mayen',
	},
	{
		'value': 'SE',
		'text':  'Sverige',
	},
	{
		'value': 'ZA',
		'text':  'Sydafrika',
	},
	{
		'value': 'GS',
		'text':  'Sydgeorgien och Sydsandwichöarna',
	},
	{
		'value': 'KR',
		'text':  'Sydkorea',
	},
	{
		'value': 'SS',
		'text':  'Sydsudan',
	},
	{
		'value': 'SY',
		'text':  'Syrien',
	},
	{
		'value': 'TJ',
		'text':  'Tadjikistan',
	},
	{
		'value': 'TW',
		'text':  'Taiwan',
	},
	{
		'value': 'TZ',
		'text':  'Tanzania',
	},
	{
		'value': 'TD',
		'text':  'Tchad',
	},
	{
		'value': 'TH',
		'text':  'Thailand',
	},
	{
		'value': 'CZ',
		'text':  'Tjeckien',
	},
	{
		'value': 'TG',
		'text':  'Togo',
	},
	{
		'value': 'TK',
		'text':  'Tokelau',
	},
	{
		'value': 'TO',
		'text':  'Tonga',
	},
	{
		'value': 'TT',
		'text':  'Trinidad och Tobago',
	},
	{
		'value': 'TN',
		'text':  'Tunisien',
	},
	{
		'value': 'TR',
		'text':  'Turkiet',
	},
	{
		'value': 'TM',
		'text':  'Turkmenistan',
	},
	{
		'value': 'TC',
		'text':  'Turks och Caicosöarna',
	},
	{
		'value': 'TV',
		'text':  'Tuvalu',
	},
	{
		'value': 'DE',
		'text':  'Tyskland',
	},
	{
		'value': 'UG',
		'text':  'Uganda',
	},
	{
		'value': 'UA',
		'text':  'Ukraina',
	},
	{
		'value': 'HU',
		'text':  'Ungern',
	},
	{
		'value': 'UY',
		'text':  'Uruguay',
	},
	{
		'value': 'US',
		'text':  'USA',
	},
	{
		'value': 'UZ',
		'text':  'Uzbekistan',
	},
	{
		'value': 'VU',
		'text':  'Vanuatu',
	},
	{
		'value': 'VA',
		'text':  'Vatikanstaten',
	},
	{
		'value': 'VE',
		'text':  'Venezuela',
	},
	{
		'value': 'VN',
		'text':  'Vietnam',
	},
	{
		'value': 'EH',
		'text':  'Västsahara',
	},
	{
		'value': 'WF',
		'text':  'Wallis och Futunaöarna',
	},
	{
		'value': 'ZM',
		'text':  'Zambia',
	},
	{
		'value': 'ZW',
		'text':  'Zimbabwe',
	},
	{
		'value': 'AX',
		'text':  'Åland',
	},
	{
		'value': 'AT',
		'text':  'Österrike',
	},
	{
		'value': 'TL',
		'text':  'Östtimor',
	},
	{
		'value': 'XK',
		'text':  'Kosovo',
	},
];

export const CSVDELIMITEROPTIONS = [
	{value: ',', text: 'Kommatecken'},
	{value: ';', text: 'Semikolon'},
	{value: ' ', text: 'Blanksteg'},
	{value: '	', text: 'Tabb'},
];

export const CSVWRAPOPTIONS = [
	{value: '"', text: '" (citattecken)'},
	{value: '\'', text: '\' (apostrof)'},
	{value: '', text: 'Tomt (ingen avgränsare)'},
];

export const CSVCHARSETOPTIONS = [
	{value: 'windows-1252', text: 'ANSI (windows-1252)'},
	{value: 'utf-8', text: 'UTF-8'},
];

export const SUSUtbTyp = [
	{value: '01', text: 'Lön, ordinarie (01)'},
	{value: '02', text: 'Lön, extra (02)'},
	{value: '05', text: 'Insättning (05)'},
	{value: '08', text: 'Utbetalning (08)'},
	{value: '40', text: 'Ersättning (40)'},
	{value: '42', text: 'Specialersättning (42)'},
];

export const KPATyp = [
	{value: '06', text: 'KAP-KL', visible: true},
	{value: '13', text: 'AKAP-KR', visible: true},
].filter(({visible}) => visible);

export const STANDARD_LONEARTSTABELLER =  [
	{value: 'STANDARD', text: 'Standardtabell'},
	{value: 'HANDELS', text: 'Handels'},
	{value: 'LSS AUTO', text: 'LSS Standard (automatiska val)'},
	{value: 'TRANSP', text: 'Transport'},
];

export default {};
